import { AccountActionType, UserLockReason } from '../user/userProfile'

export type AccountActionEntry = {
  id: number
  userId: string
  email: string
  type: AccountActionType
  reason?: UserLockReason
  details?: string
  performedBy?: string
  createdDate: string
}

export enum LoginStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export type LoginAuditEntry = {
  id: number
  email: string
  userId?: string
  ipAddress?: string
  location?: string
  status: LoginStatus
  createdDate: string
}
